import { gql } from '@apollo/client';

// Operation name `StudentGroupAttendance` is deliberately distinct from the
// backend field `myAttendance` — equal operation/field names make codegen
// collapse the generated result type into the schema payload type
// (graphql-codegen skill).
//
// Self-scoped on the server: there is no student argument, the rows come from
// the token. `attendance` is nullable on purpose — null means the teacher has
// not filled the journal for that lesson yet, which is NOT an absence.
export const StudentGroupAttendanceQuery = gql`
  query StudentGroupAttendance($groupId: ID!) {
    myAttendance(groupId: $groupId) {
      lessonId
      lessonName
      lessonNumber
      date
      attendance
    }
  }
`;
